import { forwardRef, type InputHTMLAttributes } from 'react'
import { Icon } from '@w7/ui'

export const PasswordInput = forwardRef<
  HTMLInputElement,
  {
    id: string
    describedBy?: string
    invalid?: boolean
    /** Green border once the value meets policy (ignored when invalid). */
    valid?: boolean
    value: string
    onChange: (value: string) => void
    onBlur?: InputHTMLAttributes<HTMLInputElement>['onBlur']
    autoComplete?: string
    visible: boolean
    onToggleVisible: () => void
  }
>(function PasswordInput(
  {
    id,
    describedBy,
    invalid,
    valid,
    value,
    onChange,
    onBlur,
    autoComplete,
    visible,
    onToggleVisible,
  },
  ref,
) {
  return (
    <span className="w7-password">
      <input
        ref={ref}
        id={id}
        className="w7-input"
        type={visible ? 'text' : 'password'}
        aria-describedby={describedBy}
        aria-invalid={invalid || undefined}
        data-valid={!invalid && valid ? 'true' : undefined}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        className="w7-password-toggle"
        aria-label={visible ? 'Hide password' : 'Show password'}
        onClick={onToggleVisible}
      >
        <Icon name={visible ? 'eye-off' : 'eye'} size={16} />
      </button>
    </span>
  )
})
